
import { Component, Vue, Prop } from "vue-property-decorator";
import MaterialValidationSettingsComponent from "../../components/MaterialValidationSettingsComponent.vue";
import NewMaterialDialog from "@/components/NewMaterialDialog.vue";
import CompareMaterialDialog from "@/components/CompareMaterialDialog.vue";
import httpClient from "../../store/httpClient";
@Component({
	components: {
		MaterialValidationSettingsComponent,
		NewMaterialDialog,
		CompareMaterialDialog,
	},
})
export default class MaterialSettings extends Vue {
	private editDialogOpen: boolean = false;
	private editRohmaterialId: number | null = null;
	private editRohmaterialBezeichnung: string = "";
	private loading: boolean = false;
	private werkstoffEntgratenSettingDtos: any = [];
	private newMaterialDialog: boolean = false;
	private newMaterialWerkstoffName = "";
	private compareMaterialWerkstoffName = "";
	private compareMaterialDialog: boolean = false;
	private compareMaterialBaseMaterial: any = {};

	private mounted() {
		this.loadSettings();
	}

	private get newMaterialMaterialList(): any[] {
		if (this.werkstoffEntgratenSettingDtos.length > 0) {
			let materials: any[] = [];
			this.werkstoffEntgratenSettingDtos.forEach((s: any) => {
				s.rohmaterialEntgratenSettings.forEach((res: any) => {
					let displayName = `${s.werkstoffBezeichnung} - ${res.bezeichnung}`;
					materials.push({
						id: res.rohmaterialId,
						name: res.bezeichnung,
						displayName: displayName,
					});
				});
			});
			return materials;
		}
		return [];
	}

	private async loadSettings() {
		try {
			this.loading = true;
			const response = await httpClient().get(`Material/GetMaterialSettings`);
			this.werkstoffEntgratenSettingDtos = response.data;
		} catch {
			console.log("Loading settings failed.");
		} finally {
			this.loading = false;
		}
	}

	private async updateEntgratSettings(material: any) {
		try {
			this.loading = true;
			const response = await httpClient().post(`Material/SaveEntgratSettings`, material);
			this.$store.commit("setSnackbarText", "Änderungen erfolgreich gespeichert.");
		} catch (err) {
			this.$store.commit(
				"setSnackbarErrorText",
				"Änderungen konnten nicht gespeichert werden."
			);
			console.log("Save settings failed.", err);
		} finally {
			this.loading = false;
		}
	}

	private async updatePowderCoatingSettings(material: any) {
		try {
			this.loading = true;
			const response = await httpClient().post(
				`Material/SavePowderCoatingSettings`,
				material
			);
			this.$store.commit("setSnackbarText", "Änderungen erfolgreich gespeichert.");
		} catch (err) {
			this.$store.commit(
				"setSnackbarErrorText",
				"Änderungen konnten nicht gespeichert werden."
			);
			console.log("Save settings failed.", err);
		} finally {
			this.loading = false;
		}
	}

	private async updateZincCoatingSettings(material: any) {
		try {
			this.loading = true;
			const response = await httpClient().post(`Material/SaveZincCoatingSettings`, material);
			this.$store.commit("setSnackbarText", "Änderungen erfolgreich gespeichert.");
		} catch (err) {
			this.$store.commit(
				"setSnackbarErrorText",
				"Änderungen konnten nicht gespeichert werden."
			);
			console.log("Save settings failed.", err);
		} finally {
			this.loading = false;
		}
	}

	private openValidationSettings(rohmaterial: any) {
		this.editRohmaterialId = rohmaterial.rohmaterialId;
		this.editRohmaterialBezeichnung = rohmaterial.bezeichnung;
		this.editDialogOpen = true;
	}

	private openNewMaterialDialog(werkstoffBezeichnung: string) {
		this.newMaterialWerkstoffName = werkstoffBezeichnung;
		this.newMaterialDialog = true;
	}

	private openCompareMaterialDialog(baseMaterial: any, werkstoffBezeichnung: string) {
		this.compareMaterialWerkstoffName = werkstoffBezeichnung;
		this.compareMaterialBaseMaterial = baseMaterial;
		this.compareMaterialDialog = true;
	}

	private async createNewMaterial(data: any) {
		try {
			this.loading = true;
			const response = await httpClient().post(
				`Material/CreateNewMaterialOnBasisOfExisting`,
				data
			);
			this.newMaterialDialog = false;
			this.$store.commit("setSnackbarText", "Neues Material erstellt.");
			// Reload materials to get the newly added one
			await this.loadSettings();
		} catch (err) {
			this.$store.commit("setSnackbarErrorText", "Material konnte nicht erstellt werden.");
		} finally {
			this.loading = false;
		}
	}

	private async copyMaterial(data: any) {
		try {
			this.loading = true;
			const response = await httpClient().post(`Material/CopyMaterialSettings`, data);
			this.compareMaterialDialog = false;
			this.$store.commit("setSnackbarText", "Materialeinstellungen erfolgreich kopiert.");
			// Reload materials to get the newly added one
			await this.loadSettings();
		} catch (err) {
			this.$store.commit(
				"setSnackbarErrorText",
				"Materialeinstellungen konnten nicht kopiert werden."
			);
		} finally {
			this.loading = false;
		}
	}
}
